<template lang="pug">
  div
    b-img(v-if="mapImage", rounded, :src="mapImage", fluid)
    b-button.message-button(variant="outline-primary", :href="mapLink", target="_blank" )
      map-pin-icon.icon-md.mr-2.align-top
      span Ubicación
</template>

<script>
export default {
  name: 'LocationMessage',
  props: {
    latitude: {
      type: String,
      default: ''
    },
    longitude: {
      type: String,
      default: ''
    }
  },
  computed: {
    mapImage() {
      if(!this.latitude && !this.longitude) return false
      return `https://maps.googleapis.com/maps/api/staticmap?center=${this.latitude},${this.longitude}&size=300x300&zoom=14&key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo&language=es`
    },
    mapLink() {
      return `https://www.google.com/maps/place/${this.latitude},${this.longitude}`
    }
  },
}
</script>

<style scoped>

</style>